import React, { useEffect } from "react";
import SectionHeading from "../common/SectionHeading";
import { LuSend } from "react-icons/lu";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useInView } from "react-intersection-observer";
import { setActiveSection } from "../../reducers/slices/navSlice";
import { fadeIn } from "../../utils/motion";

const Contact = () => {
    const dispatch = useDispatch();
    const { ref, inView } = useInView({ threshold: 0.5 });
    const { timeOfLastClick } = useSelector((state) => state.activeSec);

    useEffect(() => {
        if (inView && Date.now() - timeOfLastClick > 1000) {
            dispatch(setActiveSection("contact"));
        }
    }, [inView]);

    return (
        <section ref={ref} id="contact" className="scroll-mt-20 py-24 relative overflow-hidden">
            <SectionHeading text="Get In Touch" />
            
            <div className="w-[95%] max-w-[800px] mx-auto mt-12 relative flex flex-col items-center">
                {/* Background Glow */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-accent-primary/10 blur-[100px] rounded-full pointer-events-none z-0"></div>

                <motion.div 
                    initial="hidden"
                    whileInView="show"
                    variants={fadeIn("up", "tween", 0.2, 0.8)}
                    className="relative z-10 text-center mb-10"
                >
                    <p className="text-gray-600 dark:text-gray-400 text-lg md:text-xl">
                        Please contact me directly at {" "}
                        <a href="mailto:rizwansalmanirsa@gmail.com" className="text-accent-primary font-medium hover:underline underline-offset-4 decoration-accent-primary/50 transition-all">
                            rizwansalmanirsa@gmail.com
                        </a>
                        {" "} or through this form.
                    </p>
                </motion.div>

                <motion.form 
                    initial="hidden"
                    whileInView="show"
                    variants={fadeIn("up", "tween", 0.4, 0.8)}
                    className="w-full max-w-[600px] flex flex-col gap-6 relative z-10 glass p-8 md:p-10 rounded-3xl shadow-glass border border-white/10"
                >
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Your Email</label>
                        <input
                            type="email"
                            placeholder="hello@example.com"
                            className="w-full bg-white/50 dark:bg-premium-surface/80 outline-none border border-gray-200 dark:border-white/10 py-3 px-4 rounded-xl text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:border-accent-primary focus:ring-2 focus:ring-accent-primary/20 transition-all duration-300"
                        />
                    </div>
                    
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Your Message</label>
                        <textarea
                            placeholder="How can I help you?"
                            className="w-full bg-white/50 dark:bg-premium-surface/80 outline-none border border-gray-200 dark:border-white/10 py-3 px-4 rounded-xl h-[180px] resize-none text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:border-accent-primary focus:ring-2 focus:ring-accent-primary/20 transition-all duration-300"
                        ></textarea>
                    </div>

                    <motion.button
                        className="mt-2 w-full md:w-auto self-start flex justify-center items-center gap-2 bg-accent-primary text-white py-3 px-8 rounded-full font-semibold hover:bg-indigo-600 transition-all duration-300 shadow-[0_0_20px_rgba(99,102,241,0.4)] hover:shadow-[0_0_30px_rgba(99,102,241,0.6)] group"
                        onClick={(e) => { e.preventDefault(); }}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                    >
                        <span>Send Message</span>
                        <LuSend
                            size={18}
                            className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300"
                        />
                    </motion.button>
                </motion.form>
            </div>
        </section>
    );
};

export default Contact;
